import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ConnectionGuard } from './connection-guard';
import { AlleBohrpunkteComponent } from './alle-bohrpunkte/alle-bohrpunkte.component';
import { ListenverwaltungComponent } from './listenverwaltung/listenverwaltung.component';
import { HandbuchComponent } from './handbuch/handbuch.component';

// Bohrpunkte-Komponenten für Routing (Barrel-Import)
import {
	BohrpunktComponent,
	BohrpunktPrintViewComponent,
	MultiPrintViewComponent,
	BohrpunktTabsComponent,
	bohrpunktDetailResolver,
	bohrpunkteDetailResolver,
	AdresseComponent,
	AufnahmeComponent,
	BemerkungenComponent,
	BodenComponent,
	NaturraumComponent,
	SubstrateHorizonteComponent,
	VegetationsaufnahmeComponent,
	KurzprotokollComponent,
	ErrorComponent,
	SandboxControlsComponent
} from './bohrpunkte';

const canDeactivateBp = (c: BohrpunktComponent) => c.canDeactivate();

const routes: Routes = [
	{
		path: '',
		component: AlleBohrpunkteComponent,
		canActivate: [ConnectionGuard]
	},
	{
		path: 'listenverwaltung',
		component: ListenverwaltungComponent
	},
	{
		path: 'handbuch',
		component: HandbuchComponent
	},
	// Bohrpunkte-Routen (ehemals BohrpunkteRoutingModule)
	{
		path: 'bohrpunkte/:id',
		component: BohrpunktComponent,
		canDeactivate: [canDeactivateBp],
		resolve: {
			bp: bohrpunktDetailResolver,
			bps: bohrpunkteDetailResolver
		},
		children: [
			{ path: '', component: BohrpunktTabsComponent },
			{ path: 'Adresse', component: AdresseComponent },
			{ path: 'Aufnahme', component: AufnahmeComponent },
			{ path: 'Bemerkungen', component: BemerkungenComponent },
			{ path: 'Boden', component: BodenComponent },
			{ path: 'Naturraum', component: NaturraumComponent },
			{ path: 'Substrate-Horizonte', component: SubstrateHorizonteComponent },
			{ path: 'Vegetationsaufnahme', component: VegetationsaufnahmeComponent },
			{ path: 'Kurzprotokoll', component: KurzprotokollComponent },
		],
	},
	{ path: 'bohrpunkte/sandbox', component: SandboxControlsComponent },
	{ path: 'bohrpunkte/Drucken/multi', component: MultiPrintViewComponent },
	{
		path: 'bohrpunkte/Drucken/:id',
		component: BohrpunktPrintViewComponent,
		resolve: {
			bp: bohrpunktDetailResolver,
			bps: bohrpunkteDetailResolver
		}
	},
	{ path: 'bohrpunkte', component: ErrorComponent }
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule { }
